var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "ag-grid-vue",
    _vm._g(
      _vm._b(
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "ag-theme-quartz risolto-ag-grid",
          class: _vm.gridClass,
          attrs: {
            "column-defs": _vm.processedColumnDefs,
            "row-data": _vm.rowData,
            pagination: _vm.pagination,
            "pagination-page-size": _vm.paginationPageSize,
            "pagination-page-size-selector": _vm.paginationPageSizeSelector,
            "locale-text": _vm.agGridLocale,
            "suppress-cell-focus": _vm.suppressCellFocus
          },
          on: { "state-updated": _vm.onGridStateUpdated }
        },
        "ag-grid-vue",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }